import { clsx } from "clsx";
import * as m from "motion/react-m";
import { AnimatePresence } from "motion/react";
import { ConvAITerms } from "@ui/components/demos/ConvAI/ConvAITermsModal";

export function AgentTermsOverlay({
  showTermsFor,
  onAgree,
  onClose,
  showGradients = true,
  scrollOnCard = false,
  compact = false,
}: {
  showTermsFor: "text" | "voice" | null;
  onAgree: () => void;
  onClose: () => void;
  showGradients?: boolean;
  /** When true, the overlay itself doesn't scroll -- the parent card handles scrolling */
  scrollOnCard?: boolean;
  /** Tighter layout for short demo cards (e.g. Speech Engine developer omnibox). */
  compact?: boolean;
}) {
  const overlayScrolls = compact || !scrollOnCard;

  return (
    <AnimatePresence initial={false}>
      {showTermsFor !== null && (
        <m.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { delay: 0.15 } }}
          exit={{ opacity: 0 }}
          className={clsx(
            "tw-bg-cream tw-rounded-3xl sm:tw-bg-transparent tw-absolute tw-z-20 tw-inset-0 tw-flex tw-flex-col tw-items-center tw-pointer-events-auto",
            compact ? "tw-justify-start tw-px-4 tw-py-3 sm:tw-py-4" : "tw-justify-center tw-px-6 md:tw-pb-6",
            overlayScrolls && "tw-overflow-y-auto tw-overscroll-contain",
          )}
        >
          <div className={clsx("tw-min-h-0 tw-w-full", compact ? "tw-max-w-[20rem]" : "tw-max-w-md")}>
            {showGradients && <div className='tw-sticky tw-top-0 tw-bg-gradient-to-b tw-from-cream tw-h-6' />}
            <ConvAITerms
              onAgree={onAgree}
              onClose={onClose}
              compact={compact}
              contentClassName={compact ? "tw-px-3" : undefined}
            />
            {showGradients && <div className='tw-sticky tw-bottom-0 tw-bg-gradient-to-t tw-from-cream tw-h-6' />}
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
}
